var React = require('react');

function Shopping (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.8 11.4999C15.8 11.8299 16.07 12.0999 16.4 12.0999C16.73 12.0999 17 11.8299 17 11.4999V10.0999H19.3V19.2999C19.3 20.0699 18.67 20.6999 17.9 20.6999H6.1C5.33 20.6999 4.7 20.0699 4.7 19.2999V10.0999H7V11.4999C7 11.8299 7.27 12.0999 7.6 12.0999C7.93 12.0999 8.2 11.8299 8.2 11.4999V10.0999H15.8V11.4999ZM17 8.8999H19.9C20.23 8.8999 20.5 9.1699 20.5 9.4999V19.2999C20.5 20.7299 19.33 21.8999 17.9 21.8999H6.1C4.67 21.8999 3.5 20.7299 3.5 19.2999V9.4999C3.5 9.1699 3.77 8.8999 4.1 8.8999H7V7.09985C7 4.33985 9.24 2.09985 12 2.09985C14.76 2.09985 17 4.33985 17 7.09985V8.8999ZM8.2 8.8999V7.09985C8.2 4.99985 9.9 3.29985 12 3.29985C14.1 3.29985 15.8 5.00985 15.8 7.09985V8.8999H8.2Z"}));
}

Shopping.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Shopping;

Shopping.default = Shopping;
